<template>
  <div>
    <loader :show="enviando"/>
    <b-row>
      <b-col sm="12" md="12">
        <b-card header-tag="header" >
          <div slot="header">
            <strong> {{ titulo }} </strong>
          </div>
          <b-row>
            <b-col sm="12" md="12">
              <b-card>
                  <b-card-body>
                      <b-button 
                            variant="secondary"
                            @click="regresar()">
                            Regresar
                        </b-button>
                  </b-card-body>

                  <item-header
                    :headerUp="header"
                    tipoItem="menu"
                    @enviandoStart="enviando=true"
                    @enviandoStop="enviando=false"
                  ></item-header>

                <!--  ========================== SECCIONES ================================ -->

                  <item-secciones
                    :seccionesUp="secciones"
                    tipoItem="menu"
                    @enviandoStart="enviando=true"
                    @enviandoStop="enviando=false"
                  ></item-secciones>

                   <!--  ========================== IMAGENES ================================ -->
                  <!-- 
                  <item-imagenes
                    :imagenes="imagenes"
                    tipoItem="menu"
                    @enviandoStart="enviando=true"
                    @enviandoStop="enviando=false"
                    @nuevaImagen="nuevaImagen"
                    @eliminaImagen="eliminaImagen"
                    @imagenVisible="imagenVisible"
                  ></item-imagenes> -->

                  <!--  ========================== BLOQUES ================================ -->

                  <b-card-body>
                    <p v-if="bloques.length === 0"><i>No se han cargado bloques de texto...</i></p>
                    <item-bloque v-else
                      v-for="(element, index) in bloques"
                      :key="index"
                      :bloque="element"
                      tipoItem="menu"
                      @enviandoStart="enviando=true"
                      @enviandoStop="enviando=false"
                      @eliminar="eliminarBloque(index)"
                      @bloqueVisible="bloqueVisible"
                    />
                  
                  <b-button v-if="puedeAgregarBloque"
                      variant="primary"
                      size="sm"
                      class="pull-right"
                      @click="agregarBloque()"
                      @enviandoStart="enviando=true"
                      @enviandoStop="enviando=false">
                      Agregar bloque
                  </b-button>

                  </b-card-body>

                  <!--  ========================== ARCHIVOS ================================ -->

                  <!-- <b-card-body>
                      <item-docs
                        :docs="docs"
                        tipoItem="menu"
                      ></item-docs>
                  </b-card-body> -->
                  
                  <b-card-body>
                      <b-button 
                            variant="secondary"
                            @click="regresar()">
                            Regresar
                        </b-button>
                  </b-card-body>
              </b-card>

            </b-col>
            
          </b-row>
        </b-card>
      </b-col>
    </b-row><!--/.row-->
  </div>
</template>

<script>

import swal from 'sweetalert'
import axios from 'axios'
import Loader from '../../Loader'
import { mapGetters } from "vuex";

import ItemHeader from './ItemHeader';
import ItemSecciones from './ItemSecciones';
import ItemImagenes from './ItemImagenes';
import ItemBloque from './ItemBloque';
import ItemDocs from './ItemDocs';


export default {
  name: 'NormaMenu',
  components: {
   Loader,
   ItemHeader,
   ItemSecciones,
   ItemDocs,
   ItemImagenes,
   ItemBloque
  },
  computed: {
    ...mapGetters([ "httpURL",  "sessionToken",  "permisos",  "role"]),
     puedeAgregarBloque(){
      if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 134) >= 0 )
        return true;
      else
        return false;
    },
  },
  data: function () {
    return {
        titulo: this.$route.name,
        //titulo: '',
        enviando: false,
        id: this.$route.params.id,
        header: {imagen:{path:null}},
        secciones:[],
        imagenes: [],
        bloques:[],
        docs:[]
    }
  },
  created(){
      //Se obtienen los elementos del menú
      if( this.role != 'administrador' && this.permisos.findIndex(x => x.numero === 109) < 0)
        this.$router.go(-1);
      this.enviando = true;
      
      axios.get(this.httpURL+'/transparencia/normatividad/menu/'+this.id,{headers:{token:this.sessionToken}})
              .then(res => {
                  //console.log(res.data);
                  this.header = {
                     
                      imagen: res.data.menu.imagen,
                      nombre: res.data.menu.nombre,
                      descripcion: res.data.menu.descripcion
                  }
                  this.secciones = res.data.menu.secciones;
                  this.imagenes = res.data.menu.imagenes;
                  this.bloques = res.data.menu.bloques;
                  this.docs = res.data.menu.docs;
                  this.enviando = false;
              })
              .catch(error => {
                  if(error.response){
                      swal("Oops!",error.response.data.mensaje , "error")
                  }else if( error.request){
                      swal("Oops!",'No se pudo establecer una conexión al servidor. \nVerifique su conexión a internet.' , "error")
                  }
                  this.enviando = false;
              });
  },
  methods: {
    regresar(){
        this.$router.go(-1);
    },
    imageChanged(imagen){
      this.header.imagen = imagen;
    },
    nuevaImagen(imagen){
      this.imagenes.push(imagen);
    },
    imagenVisible(data){
      let index = this.imagenes.findIndex(x=>x._id == data.img);
      this.imagenes[index].visible = data.visible;
    },
    eliminaImagen(index){
      this.imagenes.splice(index,1);
      // console.log('Index '+index);
    },
    bloqueVisible(data){
      let index = this.bloques.findIndex(x=>x._id == data.id);
      this.bloques[index].visible = data.visible;
    },
    agregarBloque(){
      this.enviando = true;
      axios.post(this.httpURL+'/transparencia/normatividad/bloque/menu/'+this.$route.params.id,
                {},
                {headers: {token:this.sessionToken}})
            .then(res => {
                this.enviando = false;
                this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                          text: res.data.mensaje });
                this.bloques.push(res.data.bloque);
                
            })
            .catch(error => {
                this.enviando = false;
                if(error.response){
                    //console.log(error.response);
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: error.response.data.mensaje });
                }else if( error.request){
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: 'No se pudo establecer una conexión al servidor.' });
                }
            });
    },
    eliminarBloque(index){
      this.bloques.splice(index,1);
    },
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>